module.exports = __webpack_public_path__ + "static/flaming_fist_shield_bg3-16efcef8e5852d704a26a2d460d5c0eb.webp";